import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { ReactComponent as Logo } from "../../shared/Icons/logo.svg";
import tokenUtils from "utils";

import styles from "./Header.module.scss";

const handleOnClickLogoutButton = (navigate) => {
  Cookies.remove("jweToken");
  localStorage.clear();
  navigate("/login");
};

const handleOnClickUploadButton = (navigate) => {
  navigate("/upload");
};

const handleOnClickHomeButton = (navigate) => {
  navigate("/homePage")
}

const handleOnClickDownloadButton = (navigate) => {
  navigate("/download");
};

const Header = () => {
  const navigate = useNavigate();
  const loggedIn = tokenUtils.isValidUser();

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerRoutes}>
        <div className={styles.logoAndHomeIconContainer}>
          <Logo />
        </div>
        {loggedIn && (
          <div
            className={styles.headerButtons}
            onClick={() => handleOnClickHomeButton(navigate)}
          >
            Home
          </div>
        )}
        {loggedIn && (
          <div
            className={styles.headerButtons}
            onClick={() => handleOnClickUploadButton(navigate)}
          >
            Upload
          </div>
        )}

        {loggedIn && (
          <div
            className={styles.headerButtons}
            onClick={() => handleOnClickDownloadButton(navigate)}
          >
            Download
          </div>
        )}
      </div>
      {loggedIn && (
        <div
          className={styles.logOutButton}
          onClick={() => handleOnClickLogoutButton(navigate)}
        >
          Logout
        </div>
      )}
    </div>
  );
};

export default Header;
